import React from "react";

import IconCheckCircleDisabled from "../../../containers/assets/icon-check-circle.svg";
import IconCheckCircleActive from "../../../containers/assets/icon-check-circle-active.svg";
import IconCheckSquare from "../../../containers/assets/icon-check-square.svg";
import IconCheckClosedIncompleted from "../../../containers/assets/icon-check-circle-disabled.svg";
import TimeIcon from "../../../containers/assets/time-icon.svg";
import TimeIconActive from "../../../containers/assets/time-icon-active.svg";
import MarketButton from "../../../containers/market-button";
import moment from "moment-timezone";
import jstz from "jstz";
import cn from "classnames";

const getButtonText = (
  isSubmitted,
  hasFeedbacks,
  isStarted,
  isEnded,
  isEndedWithExtendedWithExtended,
  viewOnly
) => {
  if (isEndedWithExtendedWithExtended || viewOnly) {
    return "View";
  }

  if (isSubmitted || (isEnded && !isEndedWithExtendedWithExtended)) {
    return "Edit";
  }

  if (isStarted && hasFeedbacks) {
    return "Continue";
  }

  return "Start";
};

const getTimestampMark = (isStarted, isEndedWithExtended) => {
  if (isStarted || isEndedWithExtended) {
    return "Due ";
  } else {
    return "Open ";
  }
};

const getButtonType = (isSubmitted, hasFeedbacks, isStarted, isEnded, isEndedWithExtended, onClick, viewOnly) => {
  const buttonText = getButtonText(isSubmitted, hasFeedbacks, isStarted, isEnded, isEndedWithExtended, viewOnly);

  if (isSubmitted || isEndedWithExtended || viewOnly) {
    return (
      <MarketButton variant="primary" type="outlined" onClick={onClick}>
        {buttonText}
      </MarketButton>
    );
  } else {
    return (
      <MarketButton
        variant="error"
        type="solid"
        disabled={!isStarted}
        onClick={onClick}
      >
        {buttonText}
      </MarketButton>
    );
  }
};

const getCorrectDate = ({ start, end }) => moment.utc().isAfter(start) ? end : start;

const PeerEvaluationCard = props => {
  const {
    isSubmitted,
    hasFeedbacks,
    isEnded,
    isEndedWithExtended,
    isSurveyCompleted,
    defaultPeerEvaluationCard = true,
    isStarted,
    onClick,
    survey,
    displayCheckMark,
    viewOnly,
    completedAt
  } = props;
  const { name } = survey;
  const checkMarkSrc = defaultPeerEvaluationCard
    ? isSubmitted ? IconCheckCircleActive : IconCheckCircleDisabled
    : isSurveyCompleted
      ? IconCheckCircleActive
      : isEndedWithExtended
        ? IconCheckClosedIncompleted
        : IconCheckSquare;

  const timezone = jstz.determine();
  const completedDate = moment(completedAt)
    .tz(timezone.name())
    .format("MMM DD hh:mm A");

  return (
    <div className="peerCard">
      {
        displayCheckMark &&
        <div className="peerCard__status">
          <img alt="Check Mark" src={checkMarkSrc} />
        </div>
      }
      <div className="peerCard__info">
        <div className={cn("peerCard__info__title", {
          is_ended: isEnded,
        })}>{name}</div>
        <div className={cn("peerCard__info__date", {
          is_ended: isEnded,
        })}>
          <img alt="Time Icon" src={isEnded ? TimeIcon : TimeIconActive} />
          {getTimestampMark(isStarted, isEnded)}
          {moment(getCorrectDate(survey)).format("MMM DD hh:mm A")}
        </div>
      </div>
      {
        !defaultPeerEvaluationCard &&
        <div className="peerCard__status-text">
          {
            isSurveyCompleted &&
            <div>
              <p className="completed">Completed</p>
              {completedAt && <p className="completed-date">Date: {completedDate}</p>}
            </div>
          }
          {
            !isSurveyCompleted &&
            <p className="not-completed">Incomplete</p>
          }
        </div>
      }
      {getButtonType(isSubmitted, hasFeedbacks, isStarted, isEnded, isEndedWithExtended, onClick, viewOnly)}
    </div>
  );
};

PeerEvaluationCard.propTypes = {};

export default PeerEvaluationCard;



// WEBPACK FOOTER //
// ./src/components/peer-evaluation/peer-evaluation-card/index.js